export default __webpack_public_path__ + "static/PH-Summer-Sale-Homepage-Banner-Desktop-47844db51a393f5584bb5563a6a3f829.webp";